export default "__VITE_ASSET__DR7fO7dt__"